// Guide type tabs PLP-01 --start

{
  const tabLinks = document.querySelectorAll('.js-sub-menu-link');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const tabText = entry.target.querySelector('.tag_text')?.innerText.trim() || null;
        const index = entry.target.getAttribute("data-item-index") || null;

        tagular("ElementViewed",{
          // actionOutcome: "SELECT",
          // outboundUrl:null,
          webElement: {
            elementType: "Tab",
            htmlId: null,
            location: "PLP Tabs",
            name: tabText,
            position: index,
            text: null,
            variant: null
          }
        });

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.5
  });

  tabLinks.forEach(link => observer.observe(link));

  document.querySelectorAll('.js-sub-menu-link').forEach((link) => {
    link.addEventListener('click', (e) => {
      // e.preventDefault();
      const tabText = link.querySelector('.tag_text')?.innerText.trim() || null;
      const index = link.getAttribute("data-item-index") || null;
      
      tagular("ElementClicked",{
        actionOutcome: "SELECT",
        outboundUrl:null,
        webElement: {
          elementType: "Tab",
          htmlId: null,
          location: "PLP Tabs",
          name: tabText,
          position: index,
          text: null,
          variant: null
        }
      });
    });
  }); 
}
// Guide type tabs PLP-01 --end

// Filter - Destination - Country ElementViewed PLP-02 --start

{
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        tagular('ElementViewed', {
          // actionOutcome: 'UNCHECK',
          // outboundUrl: null,
          webElement: {
            elementType: 'Checkbox',
            htmlId: null,
            location: 'PLP Filters',
            name: 'Destination',
            position: "1",
            text: null,
            variant: null
          }
        });

        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  
  const destinationFilter = document.querySelector('#facet-filter-continents-continents_group');
  if (destinationFilter) {
    observer.observe(destinationFilter);
  }
}

// Filter - Destination - Country ElementViewed PLP-02 --end

// Filter - Category - PLP-03 ElementViewed --start

{
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      let filterName = entry.target.querySelector('.filter_main_title').textContent.trim() || null;
      if (entry.isIntersecting) {
        tagular('ElementViewed', {
          // actionOutcome: 'UNCHECK',
          // outboundUrl: null,
          webElement: {
            elementType: 'Checkbox',
            htmlId: null,
            location: 'PLP Filters',
            name: filterName,
            position: "2",
            text: null,
            variant: null
          }
        });

        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  
  const categoryFilter = document.querySelector('.category_filter_custom_menu');
  if (categoryFilter) {
    observer.observe(categoryFilter);
  }
}

// Filter - Category - PLP-03 ElementViewed --end

// PLP — ProductListViewed (batch customDimensions) --start
{
  const TILE_SELECTOR = 'product-item.tag_product_card';
  const GRID_SELECTOR = '#ProductGrid';

  const IO_THRESHOLD = 0.25;
  const ROOT_MARGIN = '0px 0px -20% 0px';
  const FLUSH_DEBOUNCE_MS = 120;
  const INITIAL_FLUSH_MS = 300;
  const MUTATION_FLUSH_DELAY_MS = 200;
  const MO_DEBOUNCE_MS = 100;

  const LIST_ID = 'PLP:' + (location.pathname.split('/').pop() || 'collection');

  const viewed = new Set();
  const queue = new Set();
  let flushTimer = null;

  function uuid() {
    return (crypto?.randomUUID?.() || Math.random().toString(16).slice(2)) + Date.now().toString(16);
  }

  window.__plpViewCorr = window.__plpViewCorr || uuid();

  function getLink(el) {
    return el.querySelector(
      'a[data-tracked="true"], .product-item__image-wrapper a[href], .product-item-meta__title[href]'
    );
  }

  function extractFromTile(tile) {
    const link = getLink(tile);
    const sku = tile.getAttribute('data-sku') || link?.dataset?.productSku || null;
    return { sku };
  }

  function flush() {
    if (!queue.size) return;

    const batch = [];
    queue.forEach((sku) => {
      viewed.add(sku);
      batch.push(sku);
    });

    queue.clear();
    if (!batch.length) return;

    tagular('ProductViewed', {
      correlationId: null,
      viewCorrelationId: window.__plpViewCorr,
      listId: LIST_ID,
      product: { brand: 'SHOP', location: 'PLP' },
      customDimensions: batch.map((sku) => ({ key: 'SKU', value: String(sku) }))
    });
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting || entry.intersectionRatio < IO_THRESHOLD) continue;
        const { sku } = extractFromTile(entry.target);
        if (!sku || viewed.has(sku)) continue;

        queue.add(sku);

        clearTimeout(flushTimer);
        flushTimer = setTimeout(flush, FLUSH_DEBOUNCE_MS);

        io.unobserve(entry.target);
      }
    },
    { threshold: IO_THRESHOLD, root: null, rootMargin: ROOT_MARGIN }
  );

  Array.from(document.querySelectorAll(TILE_SELECTOR)).forEach((tile) => io.observe(tile));
  setTimeout(flush, INITIAL_FLUSH_MS);

  const grid = document.querySelector(GRID_SELECTOR);
  if (grid) {
    let moDebounceTimer = null;

    const mo = new MutationObserver(() => {
      if (moDebounceTimer) clearTimeout(moDebounceTimer);
      moDebounceTimer = setTimeout(() => {
        clearTimeout(flushTimer);
        flush();

        window.__plpViewCorr = uuid();
        queue.clear();
        io.disconnect();
        Array.from(document.querySelectorAll(TILE_SELECTOR)).forEach((t) => io.observe(t));

        setTimeout(flush, MUTATION_FLUSH_DELAY_MS);
      }, MO_DEBOUNCE_MS);
    });

    mo.observe(grid, { childList: true, subtree: true });
  }
}
// PLP — ProductListViewed (batch customDimensions) --end


// PLP — ProductClicked (delegated) --start
{
  const GRID_SELECTOR = '#ProductGrid';
  const LOCATION = 'PLP';
  const LIST_ID = 'PLP:' + (location.pathname.split('/').pop() || 'collection');

  function getAnchor(target) {
    return target.closest('a[data-tracked="true"], .product-item__image-wrapper a[href], .product-item-meta__title[href]');
  }

  function buildPayload(tile, a) {
    const sku = tile.getAttribute('data-sku') || a?.dataset?.productSku || null;
    const productId = tile.getAttribute('data-product') || null;
    const name = tile.querySelector('.product-item-meta__title')?.textContent?.trim() || null;
    const formatType = tile.querySelector('.product-item-meta__type')?.textContent?.trim() || null;
    const position = parseInt(tile.getAttribute('data-product-index') || '0', 10) || null;
    const priceTxt = tile.querySelector('.price')?.textContent || '';
    const m = priceTxt.match(/[\d,]+\.\d{2}/);
    const price = m ? parseFloat(m[0].replace(/,/g, '')) : null;

    return {
      correlationId: null,
      viewCorrelationId: window.__plpViewCorr || null,
      listId: LIST_ID,
      product: {
        brand: 'SHOP',
        category: null,
        coupon: null,
        formatSubtype: null,
        formatType,
        location: LOCATION,
        name,
        pageId: null,
        position,
        price,
        productId,
        quantity: 1,
        sku,
        subscription: { frequency: null },
        text: null,
        upc: null,
        variant: formatType,
        positionEngine: null
      }
    };
  }

  function onClick(e) {
    const a = getAnchor(e.target);
    if (!a) return;
    const tile = a.closest('product-item');
    if (!tile) return;
    tagular('ProductClicked', buildPayload(tile, a));
  }

  function attach() {
    const grid = document.querySelector(GRID_SELECTOR) || document;
    grid.removeEventListener('click', onClick, true);
    grid.addEventListener('click', onClick, { capture: true });
  }

  attach();
  document.addEventListener('shopify:section:load', attach);
  document.addEventListener('plp:refresh', attach);
}
// PLP — ProductClicked (delegated) --end

